import { Icon, InlineLoader, Paragraph, Row } from 'components';
import DirectionIcon from 'components/shared/DirectionIcon/DirectionIcon';
import { FC } from 'react';
import { parseIntoCurrencyStringWithSymbol } from 'utils';
import {
  NetworthInfoRowWrapper,
  NetworthInfoRowWrapperProps,
} from './NetworthInfoRow.styles';

interface OwnProps extends NetworthInfoRowWrapperProps {
  title: string;
  amount?: number;
  currencySymbol?: string;
  expandable?: boolean;
  onArrowClick?: () => void;
  rotateArrow?: boolean;
  showDirection?: boolean;
}

const NetworthInfoRow: FC<OwnProps> = ({
  title,
  amount,
  currencySymbol,
  variant = 'white',
  onArrowClick,
  rotateArrow,
  showDirection = true,
}) => {
  return (
    <NetworthInfoRowWrapper variant={variant}>
      <Row flex={1}>
        <Paragraph>{title}</Paragraph>
      </Row>

      <Row flex={1.2}>
        {amount === undefined ? (
          <InlineLoader />
        ) : (
          <>
            {showDirection && (
              <DirectionIcon direction={amount >= 0 ? 'in' : 'out'} />
            )}
            <Paragraph ml mlValue="auto">
              {parseIntoCurrencyStringWithSymbol(amount, currencySymbol)}
            </Paragraph>
            {onArrowClick && (
              <Icon
                ml
                icon="arrow-down"
                onClick={onArrowClick}
                style={{
                  transform: rotateArrow ? 'rotate(180deg)' : '',
                  cursor: 'pointer',
                }}
              />
            )}
          </>
        )}
      </Row>
    </NetworthInfoRowWrapper>
  );
};

export default NetworthInfoRow;
